module.exports = __webpack_public_path__ + "2ae402c33f9d6deffb418f76944e77d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/chefs-palace-empty.png
// module id = 303
// module chunks = 0